import ALIGNCENTERICON from './align-center.svg';
import ALIGNLEFTICON from './align-left.svg';
import ALIGNRIGHTICON from './align-right.svg';
import ARRANGEBRINGFORWARDICON from './bring-forward.svg';
import ARRANGEBRINGTOFRONTICON from './bring-to-front.svg';
import ARRANGESENDBACKWARDICON from './send-backward.svg';
import ARRANGESENDTOBACKICON from './send-to-back.svg';
import BOLDICON from './bold.svg';
import CARETICON from './caret.svg';
import CHECKICON from './check.svg';
import CHEVRONICON from './chevron-bottom.svg';
import CODEICON from './code.svg';
import ERRORICON from './error.svg';
import DUPLICATEICON from './duplicate.svg';
import EYEDROPPERICON from './eyedropper.svg';
import FACEBOOKICON from './social-facebook.svg';
import GITHUBICON from './social-github.svg';
import GOOGLEPLUSICON from './social-googleplus.svg';
import IMAGEICON from '../../../../../slide/domain/ui-model/elements/default-resource/img/image.svg';
import ITALICICON from './italic.svg';
import PLOTLYICON from './plotly.svg';
import QUOTEICON from './quote.svg';
import RESIZECORNERICON from './resize-corner.svg';
import SLIDEDELETEICON from './slide-delete.svg';
import SLIDENEWICON from './slide-new.svg';
import SPINNERICON from './spinner.svg';
import TEXTICON from './text.svg';
import TWITTERICON from './social-twitter.svg';
import UNDERLINEICON from './underline.svg';
import ADAPTER_SCREEN from './adpater-screen.svg';
import NOTE_AREA from './note-area.svg';
import PAGE_PLUS from './page_scale_plus.svg';
import LOCALPLAY_START from './localplay_start.svg';
import PAGE_REDUCE from './page_scale_reduce.svg';

// 图片操作
import PICROTATEICON from './pic-rotate.svg';

// 表格拖拽
import DRAGTABLEICON from './dragTable.svg';

// 工具栏
import DROPDOWNICON from './toolbar/dropDown.svg';
import MENUCHECKICON from '../../img/menu/menu-item-check.png';
import ADDON_ICON from './addon-icon.svg';
import ADDON_TOOL from './toolbar/toolbar-add-tool.svg';
import INSERT_DOC_ICON from '@tencent/docs-design-resources/pc/svg/menu_add_tencentdocs.svg';
import UPLOADFILEICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_add_localfile_24.svg';
import TOOLBAR_SVG_SPECIAL from './toolbar';
// 状态栏
import STATUSBARCLOSEFULLSCREENICON from './status-bar-close-fullscreen.svg';
import STATUSBAROPENFULLSCREENICON from './status-bar-open-fullscreen.svg';
import STATUSBARCLOSEREMARKICON from './status-bar-close-remark.svg';
import STATUSBAROPENREMARKICON from './status-bar-open-remark.svg';

// 通用
import NEWICON from './toolbar/new.svg';
import UNDOICON from './toolbar/undo.svg';
import REDOICON from './toolbar/redo.svg';
import FORMATICON from './toolbar/format.svg';
import CLEARFORMATICON from './toolbar/clearFormat.svg';
import SLIDEBACKGROUNDICON from './toolbar/slideBackground.svg';
import SLIDESIZECUSTOMICON from './toolbar/scale_custom.svg';
import SLIDESIZESTANDARDICON from './toolbar/scale4-3.svg';
import SLIDESIZEWIDEICON from './toolbar/scale16-9.svg';
import MORE_SETTING_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_setting.svg';
// 插入
import INSERTTEXTICON from './toolbar/text.svg';
import INSERTALLCON from './toolbar/tool-insert.svg';
import INSERTLINKCON from './toolbar/link.svg';
import INSERTSHAPEICON from './toolbar/shape.svg';
import INSERTPICTUREICON from './toolbar/picture.svg';
import INSERT_AUDIO_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_audio_light_24.svg';
import INSERT_VIDEO_ICON from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_video_light_24.svg';
import INSERTFORMICON from './toolbar/table.svg';
import INSERTCHARTICON from '@tencent/docs-design-resources/icon/desktop/svg/chart_column_light_24.svg';
import INSERTLATEXICOM from '@tencent/docs-design-resources/pc/svg/toolbar_add_latex.svg';
import IMAGERECOGNITION from '@tencent/docs-design-resources/icon/desktop/svg/scan_ocr_outline_24.svg';
import TOOLBARPLUGIN from '@tencent/docs-design-resources/pc/svg/toolbar_plugin.svg';
import INSERT_FOOTER_ICON from '@tencent/docs-design-resources/pc/svg/toolbar_add_header_and_footer.svg';
import INSERTCHART from '@tencent/docs-design-resources/pc/svg/toolbar_add_chart.svg';
// 文本
import TEXTBOLDICON from './toolbar/bold.svg';
import TEXTADJUSTICON from './toolbar/font_size_adjust.svg';
import TEXTFONTINCICON from './toolbar/toolbar_increase_font_size.svg';
import TEXTFONTDECICON from './toolbar/toolbar_decrease_font_size.svg';
import TEXTITALICICON from './toolbar/italic.svg';
import TEXTUNDERLINEICON from './toolbar/underline.svg';
import TEXTDELETELINEICON from './toolbar/deleteLine.svg';
import SUBSCRIPTICON from '@tencent/docs-design-resources/icon/desktop/svg/subscript_24.svg';
import SUPERSCRIPTICON from '@tencent/docs-design-resources/icon/desktop/svg/superscript_24.svg';
import TEXTFORECOLORICON from './toolbar/forecolor.svg';
import TEXTBACKCOLORICON from './toolbar/backcolor.svg';
import TEXTDIGITNUMBERICON from './toolbar/digitNumber.svg';
import TEXTITEMNUMBERICON from './toolbar/itemNumber.svg';
import TEXTFILLCOLORICON from './toolbar/fillcolor.svg';
import TEXTBOXICON from './toolbar/border_style.svg';
import BORDERICON from './toolbar/border.svg';
import EFFECTICON from './toolbar/effect.svg';
import ROWSPACINGICON from './toolbar/rowSpacing.svg';
import WORDSPACINGICON from './toolbar/wordSpacing.svg';
import DELETEICON from './toolbar/delete.svg';
import ATTACHEMENTDELETEICON from './toolbar/floatingtoolbar_dele.svg';
import GENERATEIMAGEICON from '@tencent/docs-design-resources/icon/mobile/svg/ai_newlogo_24.svg';
import AIWRTIINGICON from '@tencent/docs-design-resources/icon/desktop/svg/ai_newlogo_light_outline_24.svg';
import AIGENERATEPAGE from '@tencent/docs-design-resources/icon/desktop/svg/ai_summarize_light_24.svg';

import PICROATEICON from './toolbar/pic-roate.svg';
import PICRESETICON from './toolbar/pic-replace.svg';
import PICCLIPICON from './toolbar/pic-clip.svg';
import PICCROPWHICON from './icon_crop_wh.svg';
import PICCROPSHAPEICON from './icon_crop_shape.svg';
import PICCROPICON from './icon_crop.svg';
import PICQUICKICON from './toolbar/pic-quick.svg';
import IMAGE_TRANSPARENT_ICON from './toolbar/image-transparent.svg';

import FORMCOLORICON from './toolbar/formColor.svg';
import FORMEDITICON from './toolbar/formEdit.svg';
import FORMTYPEICON from './toolbar/formType.svg';

import NOTEICON from './toolbar/note.svg';
import SEARCHICON from './toolbar/search.svg';
import ANIM_ICON from './toolbar/anim.svg';
import SEARCH_REPLACE_ICON from './toolbar/search-replace.svg';
import LIST_MORE_ICON from './toolbar/icon_list_more.svg';

import ADDGROUPICON from './toolbar/addGroup.svg';
import REMOVEGROUPICON from './toolbar/removeGroup.svg';
import MOVEUPICON from './toolbar/moveUp.svg';
import MOVEDOWNICON from './toolbar/moveDown.svg';
import MOVETOPICON from './toolbar/moveTop.svg';
import MOVEBOTTOMICON from './toolbar/moveBottom.svg';
import SELECT_WINDOW_ICON from './toolbar/select_window.svg';
import ARRANGE from './toolbar/toolbar_arrange.svg';

import BOXICON_1 from './toolbar/box-1.svg';
import BOXICON_2 from './toolbar/box-2.svg';
import BOXICON_3 from './toolbar/box-3.svg';
import BOXICON_4 from './toolbar/box-4.svg';
import BOXICON_5 from './toolbar/box-5.svg';
import BOXICON_6 from './toolbar/box-6.svg';
import BOXICON_7 from './toolbar/box-7.svg';
import BOXICON_8 from './toolbar/box-8.svg';
import BOXICON_9 from './toolbar/box-9.svg';
import BOXICON_10 from './toolbar/box-10.svg';

import H_ALIGNLEFTICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_alignleft.svg';
import H_ALIGNRIGHTICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_alignright.svg';
import H_ALIGNCENTERICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_aligncenter.svg';
import H_ALIGNJUSTIFYICON from '@tencent/docs-design-resources/pc/svg/toolbar_paragraph_justify.svg';
import H_ALIGNDISTRIBUTEICON from '@tencent/docs-design-resources/pc/svg/scatteralignment_outline_light_24.svg';
import V_ALIGNTOPICON from './toolbar/alignTop.svg';
import V_ALIGNCENTERICON from './toolbar/alignMiddle.svg';
import V_ALIGNBOTTOMICON from './toolbar/alignBottom.svg';


// element对齐
import ELEMENT_ALIGN_LEFT_ICON from './toolbar/align/left.svg';
import ELEMENT_ALIGN_RIGHT_ICON from './toolbar/align/right.svg';
import ELEMENT_ALIGN_CENTER_ICON from './toolbar/align/hcenter.svg';
import ELEMENT_ALIGN_TOP_ICON from './toolbar/align/top.svg';
import ELEMENT_ALIGN_VERTICAL_CENTER_ICON from './toolbar/align/vcenter.svg';
import ELEMENT_ALIGN_BOTTOM_ICON from './toolbar/align/bottom.svg';
import ELEMENT_ALIGN_DIS_H_ICON from './toolbar/align/dhorizontal.svg';
import ELEMENT_ALIGN_DIS_V_ICON from './toolbar/align/dvertical.svg';

import MERGECELLICON from './toolbar/mergeCell.svg';

import CROP_WH_ICON_1_1 from './icon_wh_1_1.svg';
import CROP_WH_ICON_2_3 from './icon_wh_2_3.svg';
import CROP_WH_ICON_3_2 from './icon_wh_3_2.svg';
import CROP_WH_ICON_3_4 from './icon_wh_3_4.svg';
import CROP_WH_ICON_3_5 from './icon_wh_3_5.svg';
import CROP_WH_ICON_4_3 from './icon_wh_4_3.svg';
import CROP_WH_ICON_4_5 from './icon_wh_4_5.svg';
import CROP_WH_ICON_5_3 from './icon_wh_5_3.svg';
import CROP_WH_ICON_5_4 from './icon_wh_5_4.svg';
import CROP_WH_ICON_16_9 from './icon_wh_16_9.svg';
import CROP_WH_ICON_16_10 from './icon_wh_16_10.svg';

import FONT_SIZE_UP from './toolbar/font_size_up.svg';
import FONT_SIZE_DOWN from './toolbar/font_size_down.svg';

import STYLEPANEL_BOLD from './stylePanel/bold.svg';
import STYLEPANEL_ITALIC from './stylePanel/italic.svg';
import STYLEPANEL_UNDERLINE from './stylePanel/underline.svg';
import STYLEPANEL_DELETELINE from './stylePanel/deleteline.svg';
import STYLEPANEL_FONTSIZE_DECREASE from './stylePanel/fontsize-decrease.svg';
import STYLEPANEL_FONTSIZE_INCREASE from './stylePanel/fontsize-increase.svg';
import STYLEPANEL_FONTCOLOR from './stylePanel/fontcolor.svg';

import STYLEPANEL_HORIZONTAL_LEFT from './stylePanel/horizontal-left.svg';
import STYLEPANEL_HORIZONTAL_CENTER from './stylePanel/horizontal-center.svg';
import STYLEPANEL_HORIZONTAL_RIGHT from './stylePanel/horizontal-right.svg';
import STYLEPANEL_SYMBOL_CIRCLE from './stylePanel/item-symbol-circle.svg';
import STYLEPANEL_SYMBOL_1 from './stylePanel/item-symbol-1.svg';

import TOOLBAR_SHADOW from './toolbar/toolbar_shadow.svg';
import TOOLBAR_REFLECTION from './toolbar/toolbar_reflection.svg';
import TOOLBAR_GLOW from './toolbar/toolbar_glow.svg';
import TOOLBAR_SOFTEDGE from './toolbar/toolbar_bordersoft.svg';

import TOOLBAR_DOT from './dot.svg';
import TOOLBAR_DOT_NORMAL from './dot_normal.svg';
import TOOLBAR_PAGE_SETTING from './toolbar/toolbar_pagesettings.svg';
import TOOLBAR_QUICK_TOOL from '@tencent/docs-design-resources/icon/desktop/svg/quicktools_light_24.svg';
import INDENT_INCREASE from '@tencent/docs-design-resources/pc/svg/toolbar_indent_increase.svg';
import INDENT_REDUCE from '@tencent/docs-design-resources/pc/svg/toolbar_indent_decrease.svg';

import TOOLBAR_DOWNLOAD_ATTACHMENT from './toolbar/floatingtoolbar_download.svg';
import TOOLBAR_ICON_TEXT from './toolbar/floatingtoolbar_link_font.svg';
import TOOLBAR_ICON_WITH_TEXT from './toolbar/icon-with-text.svg';
import TOOLBAR_ICON_CARD from './toolbar/floatingtoolbar_link_card.svg';
import TOOLBAR_PREVIEW from './toolbar/preview.svg';
import MUSIC_ATTACHMENT_PREVIEW from '@tencent/docs-design-resources/pc/svg/floatingtoolbar_music.svg';

import GRADUAL_DIRECTION from '@tencent/docs-design-resources/icon/desktop/svg/toolbar_pc_gradient_linear_24.svg';
import RECT_GRADIENT from '@tencent/docs-design-resources/pc/png@3x/gradient_rectangular_24@3x.png';
import LINEAR_GRADIENT from '@tencent/docs-design-resources/pc/png@3x/gradient_linear_24@3x.png';
import RADIAL_GRADIENT from '@tencent/docs-design-resources/pc/png@3x/gradient_radial_24@3x.png';
import SHAPE_GRADIENT from '@tencent/docs-design-resources/pc/png@3x/gradient_path_24@3x.png';
import TITLE_GRADIENT from '@tencent/docs-design-resources/pc/png@3x/gradient_titleshadow_24@3x.png';

import FORMAT_TRANSFORM from './toolbar/format-transform.svg';
import VIP_DIAMOND from '@tencent/docs-design-resources/icon/desktop/svg/membership_label_12.svg';
import TOOLBAR_COLUMN from '@tencent/docs-design-resources/icon/desktop/svg/text_column_outline_light_24.svg';
import ONE_COLUMN from '@tencent/docs-design-resources/icon/desktop/svg/text_column_one_outline_light_24.svg';
import TWO_COLUMN from '@tencent/docs-design-resources/icon/desktop/svg/text_column_two_outline_light_24.svg';
import THREE_COLUMN from '@tencent/docs-design-resources/icon/desktop/svg/text_column_three_outline_light_24.svg';
import VIP_SERVICE from '@tencent/docs-design-resources/icon/desktop/svg/vip_outline_light_24.svg';
import CHANGE_THEME from '@tencent/docs-design-resources/icon/desktop/svg/style_outline_light_24.svg';
import MUTI_PICTURE_SIZE_SETTING from '@tencent/docs-design-resources/icon/desktop/svg/batch_size_pictures_light_24.svg';
import MUTI_PICTURE_POS_SETTING from '@tencent/docs-design-resources/icon/desktop/svg/batch_composition_pictures_light_24.svg';
import OCR_PICTURE from '@tencent/docs-design-resources/icon/desktop/svg/extract_text_light_24.svg';
import MORE from '@tencent/docs-design-resources/pc/svg/icon_list_more.svg';

// 图片工具栏
import TOOLBAR_REPLACE_PICTURE from '@tencent/docs-design-resources/icon/desktop/svg/replace_page_light_24.svg';
import TOOLBAR_RESET_PICTURE from '@tencent/docs-design-resources/icon/desktop/svg/restore_24.svg';
import TOOLBAR_PICTURE_CORRECTIONS from '@tencent/docs-design-resources/icon/desktop/svg/picture_correction_light_24.svg';
import TOOLBAR_PICTURE_CORLOR from '@tencent/docs-design-resources/icon/desktop/svg/color_adjustment_light_24.svg';
import TOOLBAR_PICTURE_TRANSPARENCY from '@tencent/docs-design-resources/pc/svg/toolbar_transparency.svg';
import TOOLBAR_ROTATE from '@tencent/docs-design-resources/icon/desktop/svg/rotate_right_outline_light_24.svg';
import TOOLBAR_PICTURE_TOOLS from '@tencent/docs-design-resources/icon/desktop/svg/batch_pictures_light_24.svg';
// 文字工具栏
import TOOLBAR_TEXT_EFFECT from '@tencent/docs-design-resources/icon/desktop/svg/text_effect_light_24.svg';

export const ALIGNCENTER = ALIGNCENTERICON;
export const ALIGNLEFT = ALIGNLEFTICON;
export const ALIGNRIGHT = ALIGNRIGHTICON;
export const BRINGFORWARD = ARRANGEBRINGFORWARDICON;
export const BRINGTOFRONT = ARRANGEBRINGTOFRONTICON;
export const SENDBACKWARD = ARRANGESENDBACKWARDICON;
export const SENDTOBACK = ARRANGESENDTOBACKICON;
export const BOLD = BOLDICON;
export const CARET = CARETICON;
export const CHECK = CHECKICON;
export const CHEVRON = CHEVRONICON;
export const CODE = CODEICON;
export const ERROR = ERRORICON;
export const EYEDROPPER = EYEDROPPERICON;
export const FACEBOOK = FACEBOOKICON;
export const GITHUB = GITHUBICON;
export const GOOGLEPLUS = GOOGLEPLUSICON;
export const IMAGE = IMAGEICON;
export const ITALIC = ITALICICON;
export const PLOTLY = PLOTLYICON;
export const QUOTE = QUOTEICON;
export const RESIZECORNER = RESIZECORNERICON;
export const NEWSLIDE = SLIDENEWICON;
export const DELETESLIDE = SLIDEDELETEICON;
export const DUPLICATE = DUPLICATEICON;
export const SPINNER = SPINNERICON;
export const TEXT = TEXTICON;
export const TWITTER = TWITTERICON;
export const UNDERLINE = UNDERLINEICON;
export const MORE_SETTING = MORE_SETTING_ICON;
// 图片操作
export const PICROTATE = PICROTATEICON;

// 表格拖拽
export const DRAGTABLE = DRAGTABLEICON;

// 状态栏
export const STATUSBARCLOSEFULLSCREEN = STATUSBARCLOSEFULLSCREENICON;
export const STATUSBAROPENFULLSCREEN = STATUSBAROPENFULLSCREENICON;
export const STATUSBARCLOSEREMARK = STATUSBARCLOSEREMARKICON;
export const STATUSBAROPENREMARK = STATUSBAROPENREMARKICON;
export const ADAPTER_SCREEN_ICON = ADAPTER_SCREEN;
export const NOTE_AREA_ICON = NOTE_AREA;
export const PAGE_PLUS_ICON = PAGE_PLUS;
export const LOCALPLAY_START_ICON = LOCALPLAY_START;
export const PAGE_REDUCE_ICON = PAGE_REDUCE;

// 工具栏
export const TOOLBAR_CHECK = MENUCHECKICON;
export const TOOLBAR_NEW = NEWICON;
export const TOOLBAR_UNDO = UNDOICON;
export const TOOLBAR_REDO = REDOICON;
export const TOOLBAR_DROPDOWN = DROPDOWNICON;
export const TOOLBAR_FORMAT = FORMATICON;
export const TOOLBAR_CLEARFORMAT = CLEARFORMATICON;
export const TOOLBAR_SLIDEBACKGROUND = SLIDEBACKGROUNDICON;
export const TOOLBAR_SLIDESIZE_CUSTOM = SLIDESIZECUSTOMICON;
export const TOOLBAR_SLIDESIZE_STANDARD = SLIDESIZESTANDARDICON;
export const TOOLBAR_SLIDESIZE_WIDE = SLIDESIZEWIDEICON;
export const TOOLBAR_ALL = INSERTALLCON;
export const TOOLBAR_LINK = INSERTLINKCON;
export const TOOLBAR_TEXT = INSERTTEXTICON;
export const TOOLBAR_SHAPE = INSERTSHAPEICON;
export const TOOLBAR_AI_GENERATE_PAGE = AIGENERATEPAGE;
export const TOOLBAR_PICTURE = INSERTPICTUREICON;
export const TOOLBAR_AUDIO = INSERT_AUDIO_ICON;
export const TOOLBAR_VIDEO = INSERT_VIDEO_ICON;
export const TOOLBAR_FORM = INSERTFORMICON;
export const TOOLBAR_CHART = INSERTCHARTICON;
export const TOOLBAR_LATEX = INSERTLATEXICOM;
export const TOOLBAR_IMAGE_RECOGNITION = IMAGERECOGNITION;
export const TOOLBAR_PLUGIN = TOOLBARPLUGIN;
export const TOOLBAR_ANIM = ANIM_ICON;
export const TOOLBAR_SEARCH_REPLACE = SEARCH_REPLACE_ICON;
export const TOOLBAR_ADDON = ADDON_ICON;
export const TOOLBAR_ADDON_TOOL = ADDON_TOOL;
export const TOOLBAR_UPLOAD_FILE = UPLOADFILEICON;
export const TOOLBAR_INSERT_DOC = INSERT_DOC_ICON;
export const TOOLBAR_UPLOAD_LOCAL_FILE_ICON = TOOLBAR_SVG_SPECIAL.UPLOAD_LOCAL_FILE_ICON;
export const TOOLBAR_INSERT_WEIXIN_DOC = TOOLBAR_SVG_SPECIAL.INSERT_WEIXIN_DOC;
export const TOOLBAR_INSERT_FOOTER = INSERT_FOOTER_ICON;
export const INSERT_CHART = INSERTCHART;
export const TOOLBAR_DOWNLOAD_ATTACHMENT_ICON = TOOLBAR_DOWNLOAD_ATTACHMENT;
export const TOOLBAR_ICON_TEXT_ICON = TOOLBAR_ICON_TEXT;
export const TOOLBAR_ICON_WITH_TEXT_ICON = TOOLBAR_ICON_WITH_TEXT;
export const TOOLBAR_ICON_CARD_ICON = TOOLBAR_ICON_CARD;
export const TOOLBAR_PREVIEW_ICON = TOOLBAR_PREVIEW;
export const MUSIC_ATTACHMENT_PREVIEW_ICON = MUSIC_ATTACHMENT_PREVIEW;

export const TOOLBAR_BOLD = TEXTBOLDICON;
export const TOOLBAR_FONT_SIZE_ADJUST = TEXTADJUSTICON;
export const TOOLBAR_FONT_SIZE_INCREASE = TEXTFONTINCICON;
export const TOOLBAR_FONT_SIZE_DECREASE = TEXTFONTDECICON;
export const TOOLBAR_ITALIC = TEXTITALICICON;
export const TOOLBAR_UNDERLINE = TEXTUNDERLINEICON;
export const TOOLBAR_DELETELINE = TEXTDELETELINEICON;
export const TOOLBAR_SUBSCRIPT = SUBSCRIPTICON;
export const TOOLBAR_SUPERSCRIPT = SUPERSCRIPTICON;
export const TOOLBAR_FORECOLOR = TEXTFORECOLORICON;
export const TOOLBAR_BACKCOLOR = TEXTBACKCOLORICON;
export const TOOLBAR_ALIGN = H_ALIGNLEFTICON;
export const TOOLBAR_DIGITNUMBER = TEXTDIGITNUMBERICON;
export const TOOLBAR_ITEMNUMBER = TEXTITEMNUMBERICON;
export const TOOLBAR_FILLCOLOR = TEXTFILLCOLORICON;
export const TOOLBAR_BOX = TEXTBOXICON;
export const TOOLBAR_BORDER = BORDERICON;
export const TOOLBAR_EFFECT = EFFECTICON;
export const TOOLBAR_AI_WRITTING = AIWRTIINGICON;
export const TOOLBAR_ROWSPACING = ROWSPACINGICON;
export const TOOLBAR_WORDSPACING = WORDSPACINGICON;
export const TOOLBAR_DELETE = DELETEICON;
export const TOOLBAR_ATTACHMENT_DELETE = ATTACHEMENTDELETEICON;
export const TOOLBAR_GENERATE_IMAGE = GENERATEIMAGEICON;

export const TOOLBAR_ROATE = PICROATEICON;
export const TOOLBAR_PIC_RESTORE = PICRESETICON;
export const TOOLBAR_CLIP = PICCLIPICON;
export const TOOLBAR_CROP_WH = PICCROPWHICON;
export const TOOLBAR_CROP_SHAPE = PICCROPSHAPEICON;
export const TOOLBAR_CROP = PICCROPICON;
export const TOOLBAR_QUICK = PICQUICKICON;
export const TOOLBAR_IMAGE_TRANS = IMAGE_TRANSPARENT_ICON;

export const TOOLBAR_FORMCOLOR = FORMCOLORICON;
export const TOOLBAR_FORMEDIT = FORMEDITICON;
export const TOOLBAR_FORMTYPE = FORMTYPEICON;

export const TOOLBAR_NOTE = NOTEICON;
export const TOOLBAR_SEARCH = SEARCHICON;

export const TOOLBAR_ADDGROUP = ADDGROUPICON;
export const TOOLBAR_REMOVEGROUP = REMOVEGROUPICON;
export const TOOLBAR_MOVEUP = MOVEUPICON;
export const TOOLBAR_MOVEDOWN = MOVEDOWNICON;
export const TOOLBAR_MOVETOP = MOVETOPICON;
export const TOOLBAR_MOVEBOTTOM = MOVEBOTTOMICON;
export const TOOLBAR_LISTMORE = LIST_MORE_ICON;
export const TOOLBAR_SELECT_WINDOW = SELECT_WINDOW_ICON;
export const TOOLBAR_ARRANGE = ARRANGE;
export const TOOLBAR_INSERT_FILE = TOOLBAR_SVG_SPECIAL.INSERT_FILE_ICON;
export const TOOLBAR_INSERT_WEDRIVE_ICON = TOOLBAR_SVG_SPECIAL.INSERT_WEDRIVE_ICON;

export const TOOLBAR_SLIDE_TOGGLE = TOOLBAR_SVG_SPECIAL.SLIDE_TOGGLE;
export const TOOLBAR_FORMAT_TRANSFORM = FORMAT_TRANSFORM;
export const TOOLBAR_VIP_DIAMOND = VIP_DIAMOND;

// 边框
export const TOOLBAR_BOX_1 = BOXICON_1;
export const TOOLBAR_BOX_2 = BOXICON_2;
export const TOOLBAR_BOX_3 = BOXICON_3;
export const TOOLBAR_BOX_4 = BOXICON_4;
export const TOOLBAR_BOX_5 = BOXICON_5;
export const TOOLBAR_BOX_6 = BOXICON_6;
export const TOOLBAR_BOX_7 = BOXICON_7;
export const TOOLBAR_BOX_8 = BOXICON_8;
export const TOOLBAR_BOX_9 = BOXICON_9;
export const TOOLBAR_BOX_10 = BOXICON_10;

// 对齐
export const TOOLBAR_H_ALIGN_LEFT = H_ALIGNLEFTICON;
export const TOOLBAR_H_ALIGN_RIGHT = H_ALIGNRIGHTICON;
export const TOOLBAR_H_ALIGN_CENTER = H_ALIGNCENTERICON;
export const TOOLBAR_H_ALIGN_JUSTIFY = H_ALIGNJUSTIFYICON;
export const TOOLBAR_H_ALIGN_DISTRIBUTE = H_ALIGNDISTRIBUTEICON;
export const TOOLBAR_V_ALIGN_TOP = V_ALIGNTOPICON;
export const TOOLBAR_V_ALIGN_CENTER = V_ALIGNCENTERICON;
export const TOOLBAR_V_ALIGN_BOTTOM = V_ALIGNBOTTOMICON;


// element对齐
export const ELEMENT_H_ALIGN_LEFT = ELEMENT_ALIGN_LEFT_ICON;
export const ELEMENT_H_ALIGN_RIGHT = ELEMENT_ALIGN_RIGHT_ICON;
export const ELEMENT_H_ALIGN_CENTER = ELEMENT_ALIGN_CENTER_ICON;
export const ELEMENT_H_ALIGN_VCENTER = ELEMENT_ALIGN_VERTICAL_CENTER_ICON;
export const ELEMENT_V_ALIGN_TOP = ELEMENT_ALIGN_TOP_ICON;
export const ELEMENT_V_ALIGN_BOTTOM = ELEMENT_ALIGN_BOTTOM_ICON;
export const ELEMENT_V_ALIGN_DIS = ELEMENT_ALIGN_DIS_V_ICON;
export const ELEMENT_H_ALIGN_DIS = ELEMENT_ALIGN_DIS_H_ICON;

export const TOOLBAR_MERGECELL = MERGECELLICON;

export const TOOLBAR_FONT_UP = FONT_SIZE_UP;
export const TOOLBAR_FONT_DOWN = FONT_SIZE_DOWN;

export const STYLE_PANEL_BOLD = STYLEPANEL_BOLD;
export const STYLE_PANEL_ITALIC = STYLEPANEL_ITALIC;
export const STYLE_PANEL_UNDERLINE = STYLEPANEL_UNDERLINE;
export const STYLE_PANEL_DELETELINE = STYLEPANEL_DELETELINE;
export const STYLE_PANEL_FONTSIZE_DECREASE = STYLEPANEL_FONTSIZE_DECREASE;
export const STYLE_PANEL_FONTSIZE_INCREASE = STYLEPANEL_FONTSIZE_INCREASE;
export const STYLE_PANEL_FONTCOLOR = STYLEPANEL_FONTCOLOR;

export const STYLE_PANEL_HORIZONTAL_LEFT = STYLEPANEL_HORIZONTAL_LEFT;
export const STYLE_PANEL_HORIZONTAL_CENTER = STYLEPANEL_HORIZONTAL_CENTER;
export const STYLE_PANEL_HORIZONTAL_RIGHT = STYLEPANEL_HORIZONTAL_RIGHT;
export const STYLE_PANEL_SYMBOL_CIRCLE = STYLEPANEL_SYMBOL_CIRCLE;
export const STYLE_PANEL_SYMBOL_1 = STYLEPANEL_SYMBOL_1;

export const CROP_WH_1_1 = CROP_WH_ICON_1_1;
export const CROP_WH_2_3 = CROP_WH_ICON_2_3;
export const CROP_WH_3_2 = CROP_WH_ICON_3_2;
export const CROP_WH_3_4 = CROP_WH_ICON_3_4;
export const CROP_WH_3_5 = CROP_WH_ICON_3_5;
export const CROP_WH_4_3 = CROP_WH_ICON_4_3;
export const CROP_WH_4_5 = CROP_WH_ICON_4_5;
export const CROP_WH_5_3 = CROP_WH_ICON_5_3;
export const CROP_WH_5_4 = CROP_WH_ICON_5_4;
export const CROP_WH_16_9 = CROP_WH_ICON_16_9;
export const CROP_WH_16_10 = CROP_WH_ICON_16_10;

export const TOOLBAR_SHADOW_ICON = TOOLBAR_SHADOW;
export const TOOLBAR_REFLECTION_ICON = TOOLBAR_REFLECTION;
export const TOOLBAR_GLOW_ICON = TOOLBAR_GLOW;
export const TOOLBAR_SOFTEDGE_ICON = TOOLBAR_SOFTEDGE;

export const TOOLBAR_DOT_ICON = TOOLBAR_DOT;
export const TOOLBAR_DOT_NORMAL_ICON = TOOLBAR_DOT_NORMAL;
export const TOOLBAR_PAGE_SEETING_ICON = TOOLBAR_PAGE_SETTING;
export const TOOLBAR_QUICK_TOOL_ICON = TOOLBAR_QUICK_TOOL;

export const INDENT_INCREASE_ICON = INDENT_INCREASE;
export const INDENT_REDUCE_ICON = INDENT_REDUCE;
export const RECT_GRADIENT_ICON = RECT_GRADIENT;
export const LINEAR_GRADIENT_ICON = LINEAR_GRADIENT;
export const RADIAL_GRADIENT_ICON = RADIAL_GRADIENT;
export const SHAPE_GRADIENT_ICON = SHAPE_GRADIENT;
export const GRADUAL_DIRECTION_ICON = GRADUAL_DIRECTION;
export const TITLE_GRADIENT_ICON = TITLE_GRADIENT;

export { default as MASTER_LAYOUT_ICON } from './icon_master_layout.svg';

export const TOOLBAR_COLUMN_ICON = TOOLBAR_COLUMN;
export const ONE_COLUMN_ICON = ONE_COLUMN;
export const TWO_COLUMN_ICON = TWO_COLUMN;
export const THREE_COLUMN_ICON = THREE_COLUMN;

// 会员tab
export const VIP_SERVICE_ICON = VIP_SERVICE;
export const CHANGE_THEME_ICON = CHANGE_THEME;
export const MUTI_PICTURE_SIZE_SETTING_ICON = MUTI_PICTURE_SIZE_SETTING;
export const MUTI_PICTURE_POS_SETTING_ICON = MUTI_PICTURE_POS_SETTING;
export const OCR_PICTURE_ICON = OCR_PICTURE;
export const MORE_ICON = MORE;
// 工具栏 - 图片
export const TOOLBAR_REPLACE_PICTURE_ICON = TOOLBAR_REPLACE_PICTURE;
export const TOOLBAR_RESET_PICTURE_ICON = TOOLBAR_RESET_PICTURE;
export const TOOLBAR_PICTURE_CORRECTIONS_ICON = TOOLBAR_PICTURE_CORRECTIONS;
export const TOOLBAR_PICTURE_COLOR_ICON = TOOLBAR_PICTURE_CORLOR;
export const TOOLBAR_PICTURE_TRANSPARENCY_ICON = TOOLBAR_PICTURE_TRANSPARENCY;
export const TOOLBAR_ROTATE_ICON = TOOLBAR_ROTATE;
export const TOOLBAR_PICTURE_TOOLS_ICON = TOOLBAR_PICTURE_TOOLS;
// 工具栏 - 文字
export const TOOLBAR_TEXT_EFFECT_ICON = TOOLBAR_TEXT_EFFECT;
